// Componenet that is used in the Gallery page to display image slideshow
import '../style/main.css';
import {useEffect, useState } from 'react';

function Slideshow() {
    // State to store the list of image locations provided by the website
    const [images, setImages] = useState([]);
    // State to track which image is currently displayed in the slideshow 
    const [index, setIndex] = useState(0);

    // Fetch the image URLs from the gallery-contents.json, parses and add them to the images state
    useEffect (() => {
        fetch('/gallery/gallery-contents.json')
            .then((response) => response.json())
            .then(setImages)
            .catch((error) => {
                console.error('Failed to load images', error);
                setImages([]);
            });
    }, []);

    // Display a message if images are loading and downloading to the users browser
    if (images.length === 0) {
        return <div>Loading images</div>;
    }

    // Makes the slideshow go to the next or previous slide, 1 is next -1 is previous
    const nextSlide = (n) => {
        setIndex((previous) => (
            previous + n + images.length) % images.length
        );
    };

    // Jumps to the selected slide by index
    const currentSlide = (n) => setIndex(n);

    return (
        <>
            <div class='slideshow-content' >
                {/*The slide show image is set here*/}
                <img class='slide' src={images[index]} />
                <a class='back-button' onClick={() => nextSlide(-1)}><i class='fas fa-chevron-left'></i></a>
                <a class='next-button' onClick={() => nextSlide(1)}><i class='fas fa-chevron-right'></i></a>
            </div>
            {/*Mobile buttons that appear when resolution is >= 1000px*/}
            <div>
                <a class='back-button-mobile' onClick={() => nextSlide(-1)}><i class='fas fa-chevron-left'></i></a>
                <a class='next-button-mobile' onClick={() => nextSlide(1)}><i class='fas fa-chevron-right'></i></a>
            </div>

            <div class='thumbnail-row'>
                {images.map((img, i) => (
                    <div class='thumbnail-column' key={i}>
                        <img 
                            class={`thumbnail ${i === index ? 'selected' : ''}`}
                            src={img} 
                            /*When the thumbnail is clicked it will set the slide show image directly*/
                            onClick={() => currentSlide(i)} 
                        />
                    </div>
                ))}
            </div>
        </>
        
    );
}

export default Slideshow;